export const SHADE_GUIDE_STEPS = [
  { label: 'shadeGuideAI.shadeGuideSteps.color', id: 'color' },
  { label: 'shadeGuideAI.shadeGuideSteps.material', id: 'material' },
  { label: 'shadeGuideAI.shadeGuideSteps.recipe', id: 'recipe' },
]
export enum RECIPE_TYPE {
  SINGLE_ZONE = 'single dentin',
  TRIPLE_ZONE = 'triple dentin',
}

export enum RESTORATION_METHOD {
  STAINING = 'staining',
  LAYERING = 'layering',
}

export const COLOR_FORM = {
  recipeType: {
    label: 'shadeGuideAI.colorForm.recipeType.label',
    tooltip: 'shadeGuideAI.colorForm.recipeType.tooltip',
    options: [
      {
        value: RECIPE_TYPE.SINGLE_ZONE,
        label: 'shadeGuideAI.colorForm.recipeType.options.single',
      },
      {
        value: RECIPE_TYPE.TRIPLE_ZONE,
        label: 'shadeGuideAI.colorForm.recipeType.options.triple',
      },
    ],
  },
  restorationMethod: {
    label: 'shadeGuideAI.colorForm.restorationMethod.label',
    tooltip: 'shadeGuideAI.colorForm.restorationMethod.tooltip',
    options: [
      {
        value: RESTORATION_METHOD.STAINING,
        label: 'shadeGuideAI.colorForm.restorationMethod.options.staining',
      },
      {
        value: RESTORATION_METHOD.LAYERING,
        label: 'shadeGuideAI.colorForm.restorationMethod.options.layering',
      },
    ],
  },
  stumpShade: {
    label: 'shadeGuideAI.colorForm.stumpShade.label',
    tooltip: 'shadeGuideAI.colorForm.stumpShade.tooltip',
  },
  preparationColor: {
    label: 'shadeGuideAI.colorForm.preparationColor.label',
    tooltip: 'shadeGuideAI.colorForm.preparationColor.tooltip',
  },
  targetShade: {
    label: 'shadeGuideAI.colorForm.targetShade.label',
    tooltip: 'shadeGuideAI.colorForm.targetShade.tooltip',
    value: {
      label: 'shadeGuideAI.colorForm.targetShade.value.label',
      tooltip: 'shadeGuideAI.colorForm.targetShade.value.tooltip',
    },
    chroma: {
      label: 'shadeGuideAI.colorForm.targetShade.chroma.label',
      tooltip: 'shadeGuideAI.colorForm.targetShade.chroma.tooltip',
    },
  },
}

export const MATERIAL_FORM = {
  frameworkColor: {
    label: 'shadeGuideAI.materialForm.frameworkColor.label',
    tooltip: 'shadeGuideAI.materialForm.frameworkColor.tooltip',
  },
  frameworkThickness: {
    label: 'shadeGuideAI.materialForm.frameworkThickness.label',
    tooltip: 'shadeGuideAI.materialForm.frameworkThickness.tooltip',
  },
  stainingBrand: {
    label: 'shadeGuideAI.materialForm.stainingBrand.label',
    tooltip: 'shadeGuideAI.materialForm.stainingBrand.tooltip',
  },
  ceramicBrand: {
    label: 'shadeGuideAI.materialForm.ceramicBrand.label',
    tooltip: 'shadeGuideAI.materialForm.ceramicBrand.tooltip',
  },
  availableSpace: {
    label: 'shadeGuideAI.materialForm.availableSpace.label',
    tooltip: 'shadeGuideAI.materialForm.availableSpace.tooltip',
  },
}

interface Option {
  order: number
  [key: string]: any
}

export const getOptions = (metadata: Record<string, any>, key: string) =>
  metadata?.[key as keyof typeof metadata]
    ?.flat()
    ?.sort((a: Option, b: Option) => a.order - b.order)

export enum COLOR_VALUE {
  Vita3DMaster = 'VITA3D Master',
  VitaClassic = 'VITA Classic',
  NaturalDieMaterial = 'Natural Die Material',
}

export const PREP_DROPDOWN_OPTIONS = [
  { value: COLOR_VALUE.Vita3DMaster, text: COLOR_VALUE.Vita3DMaster },
  { value: COLOR_VALUE.VitaClassic, text: COLOR_VALUE.VitaClassic },
  {
    value: COLOR_VALUE.NaturalDieMaterial,
    text: COLOR_VALUE.NaturalDieMaterial,
  },
]

export const TARGET_DROPDOWN_OPTIONS = [
  { value: COLOR_VALUE.Vita3DMaster, text: COLOR_VALUE.Vita3DMaster },
  { value: COLOR_VALUE.VitaClassic, text: COLOR_VALUE.VitaClassic },
]
